import $ from 'jquery';
import ajax from '../services/ajax';
import moment from 'moment';
import _ from 'underscore';
require('moment-timezone');

/**
 * Module to that fetches latest stories from a datasource (Attribyte for now) and renders them clientside
 */
class StoryBand {

    constructor(dataSource) {
        if (!dataSource) {
            throw ReferenceError(); // eslint-disable-line new-cap
        }
        this.dataSource = new AtrribyteInterface(dataSource);
        this.dataSourceUri = this.dataSource.buildRequestUri();
        this.$DOMWrapper = dataSource.$DOMWrapper;
        const storyBandSiteLookup = {
            fastconews: {
                humanReadableSite: 'FastCo News',
                url: '//news.fastcompany.com'
            },
            fastcodesign: {
                humanReadableSite: 'Co.Design',
                url: '//www.fastcodesign.com'
            },
            fastcoexist: {
                humanReadableSite: 'Co.Exist',
                url: '//www.fastcoexist.com'
            },
            fastcocreate: {
                humanReadableSite: 'Co.Create',
                url: '//www.fastcocreate.com'
            },
            fastcompany: {
                humanReadableSite: 'Fast Company',
                url: '//www.fastcompany.com'
            }

        };
        this.humanReadableSite = storyBandSiteLookup[this.dataSource.site].humanReadableSite;
        this.siteDestination = storyBandSiteLookup[this.dataSource.site].url;
        this.individualStoryCoSiteLookup = {
            'http:\/\/www.fastcodesign.com\/': 'Co.Design',
            'http:\/\/www.fastcocreate.com\/': 'Co.Create',
            'http:\/\/www.fastcoexist.com\/': 'Co.Exist',
            'http:\/\/www.fastcompany.com\/': 'Fast Company'
        };
    }

    /**
     * initialize() 'starts' the module, call fetch for model data and then renders when fetch is complete
     */
    initialize() {
        return this.fetch().then(this.fetchComplete.bind(this));
    }

    /**
     * constructDOM()
     * @param an array of story objects
     * @return a transformed array of DOM elements that can be joined and appended
     */

    constructDOM(stories) {
        const iterable = stories;
        const that = this; // eslint-disable-line consistent-this

        let coNewsURL = 'https://news.fastcompany.com/';

        return iterable.map(function (story) {
            // this needs to be changed when we support other story types, it's the news logo thumbnail
            let imgTag = '';
            let parentSiteURL = story.parentSite.url;
            let isCoNews = parentSiteURL === coNewsURL;
            let isCoSite = !isCoNews;
            let siteMetaData = ``;

            if (isCoSite) {
                siteMetaData = that.individualStoryCoSiteLookup[parentSiteURL] + ' |';
            }

            if (story && story.primaryImage && story.primaryImage.originalSrc) {
                imgTag = story.primaryImage.originalSrc.replace('http:', '');
            }

            let $article = $(`<article class="story-band__article story-band__article--border"></article>`);

            let $metaDataDOM = $(`
            <small class="story-band__article__meta story-band__article__meta--adjust-top-margin">
                <a class="-no-anchor-style hide-for-small display-inline-for-medium-up story-band__article__meta" href="${parentSiteURL}">
                    <span class="story-band__article__site">${siteMetaData}<span>
                </a>
                <span class="hide-for-small display-inline-for-medium-up story-band__article__meta__separator story-band__article__meta--no-site-tag">|</span>
                <time class="story-band__article__date">${moment.tz(story.publishTimestamp, 'America/New_York').format('h:mm a')}</time>
            </small>`);


            $article.append($metaDataDOM);
            let $anchorWrapper = $(`<a href="${story.canonicalLink + '?utm_source=homepage&utm_medium=web&utm_campaign=storybandhomepage'}"></a>`);


            if (imgTag) {
                $anchorWrapper.append($(`
                                <figure class="story-band__article__poster-wrapper story-band__article__poster-wrapper--adjust-top-margin">
                                    <img class="story-band__article__image image-wrapper" src="${imgTag}">
                                </figure>
                                <h3 class="story-band__article__title story-band__article__title--with-image">${that.shortenTitle(story.title, 65, 60)}</h3>`));
            } else {
                $anchorWrapper.append($(`<h3 class="story-band__article__title story-band__article__title--no-image">${that.shortenTitle(story.title)}</h3>`));
            }
            $article.append($anchorWrapper);

            return $article.prop('outerHTML');
        });
    }

    shortenTitle(title, desktopLength, mobileLength) {
        if (!title) {
            return '';
        }
        let useThisWidth = desktopLength || 90;

        if (window.innerWidth < 600 && mobileLength && typeof mobileLength === 'number') {
            useThisWidth = mobileLength;
        }

        let modifiedTitle = null;

        if (title.length > useThisWidth) {
            modifiedTitle = title.slice(0, useThisWidth) + ' ...';
        }

        return modifiedTitle || title;
    }
    /**
     * buildLinkOut()
     * @return a string containing button markup for linkout
     */
    buildCoNewsBox() {
        const buttonMarkup = `<a href="https://news.fastcompany.com"><span class="story-band__conews-box">FASTCO NEWS</span></a>`;
        return buttonMarkup;
    }

    /**
     * fetch()
     * @return a deferred ajax call to data source than can be resolved elsewhere
     */
    fetch() {
        return ajax(this.dataSourceUri, {
            method: 'GET',
            dataType: 'json'
        });
    }

    /**
     * fetchComplete() fires events that lead to render of stories
     * @param result of a promise, in this case, it resolves the deferred ajax call
     */

    fetchComplete(resp) {
        const newDOM = this.constructDOM(resp.posts);
        this.$DOMWrapper.append(newDOM.join(' '));
        if (this.dataSource.site === "fastconews") {
            this.$DOMWrapper.append(this.buildCoNewsBox());
        }

        require('./slideshow/create_story-band_slideshow')(this.$DOMWrapper);
        this.$DOMWrapper.attr('data-storyband', true);
    }
}


/**
 * Class that builds query for attribyte. Eventually will pull this out into its own file, we will be ableto customize the uri
 * for different needs
 */
class AtrribyteInterface {
    constructor(config = {}) {
        this.site = config.site;
        this.limit = config.limit;
        this.isCoNews = this.site === 'fastconews';
        this.isCoDesign = this.site === 'fastcodesign';
        this.isCoSite = !this.isCoNews;
        this.allCoSites =  `site=fastcompany&site=fastcocreate&site=fastcodesign&site=fastcoexist`;
    }

    /**
     * buildRequestUri()
     * @return uri string to call attribyte api via our all.fastcompany service
     */
    buildRequestUri() {
        let site = `site=${this.site}`;
        if (this.isCoSite) {
            site = this.allCoSites;
        }
        let uri = `https://all.fastcompany.com/api/v1/fetch?${site}&limit=${this.limit}&range=week`;
        if (this.isCoNews) {
            uri += `&time=${this.roundUpTime()}`;
        }
        // this is a hack to bypass fastly
        if (this.isCoDesign) {
            uri += `&23A82C0A-5DAC-4030-8B9D-1A2D93EF352F`;
        }
        return uri;
    }

    /**
     * roundUpTime()
     * we are sending a time string as part of our query. but we are rounding
     * up to the tenth minute to bust the CDN cache every 5 minutes, or 12
     * times per hour
     * @return string containing the unix timestamp rounded up to nearest 10 minutes
     */
    roundUpTime() {
        // special case for 0. return 9
        // Math.ceil(x/10) * 10 - 1
        let now = moment();
        let convertedTime = moment.tz(now, 'America/New_York');
        let minutes = convertedTime.minutes();

        if (minutes % 5 === 0) {
            minutes++;
        }

        let rounded = Math.ceil(minutes / 5) * 5 - 1;
        let roundedUpTime = convertedTime.minutes(rounded);
        let zeroSeconds = roundedUpTime.seconds(0);
        let zeroMilliseconds = zeroSeconds.milliseconds(0);
        return zeroMilliseconds.valueOf();
    }
}


/**
 * Class that builds query for attribyte. Eventually will pull this out into its own file,
 * we will be ableto customize the uri
 * for different needs
 */
class StoryBandBuilder {
    constructor(config = { selector: '.story-band__slideshow', limit: '18' }) {
        this.determineSiteSource();
        this.limit = config.limit;
        this.selector = config.selector;
        this.$collection = $(this.selector);
        this.individualConfig = {site: this.site, limit: this.limit};
    }

    init() {
        this.$collection = $(this.selector);
        this.$collection.each(function (index, el) {
            const $el = $(el);
            if ($el.attr('data-storyband')) {
                return;
            }
            $el.attr('data-storyband', true);
            let config = _.extend({site: this.site}, this.individualConfig, {$DOMWrapper: $el});
            new StoryBand(config).initialize();
        }.bind(this));
    }

    determineSiteSource() {
        const domain = document.location.hostname;
        if (domain.indexOf('fastcompany') !== -1) {
            this.site = 'fastconews';
        } else {
            let trimmedDomain = domain.replace('www.', '');
            trimmedDomain = trimmedDomain.replace('.com', '');
            trimmedDomain = trimmedDomain.replace('.local', '');
            trimmedDomain = trimmedDomain.replace('beta1.', '');
            trimmedDomain = trimmedDomain.replace('beta2.', '');
            trimmedDomain = trimmedDomain.replace('beta3.', '');
            trimmedDomain = trimmedDomain.replace('beta.', '');
            this.site = trimmedDomain;
        }
    }
}


export default new StoryBandBuilder({limit: '18', selector: '.story-band__slideshow'});
